// extracted by mini-css-extract-plugin
export default {"spinner":"spinner--T02EM","body":"body--iqKYi","stopped":"stopped--JwRM6","logo-spin":"logo-spin--ZORdf"};